// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("grid"),
      BsCssJs$PrezzeeRibbon.gridTemplateColumns([BsCssJs$PrezzeeRibbon.fr(1)]),
      BsCssJs$PrezzeeRibbon.gridTemplateRows(["auto"]),
      BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 2
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }]),
            BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(28)),
            BsCssJs$PrezzeeRibbon.selector("&>*:nth-of-type(odd)", [BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(54))]),
            BsCssJs$PrezzeeRibbon.selector("&>*:nth-of-type(even)", [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(54))])
          ])
    ]);

var Styles = {
  container: container
};

function OffsetBlocks(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    container,
                    className$1
                  ])
            });
}

var Block;

var Heading;

var Description;

var Content;

var make = OffsetBlocks;

export {
  Block ,
  Heading ,
  Description ,
  Content ,
  Styles ,
  make ,
}
/* container Not a pure module */
